import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/pages/index'
import Login from '@/pages/login/index'
import Account from '@/pages/user/index'
import Payment from '@/pages/payment/index'
import Card from '@/pages/card/index'
import Invoice from '@/pages/invoice/index'
import Setting from '@/pages/setting/index'
import Withdrawal from '@/pages/withdrawal/index'
import ResetPassword from '@/pages/reset-password/index'
import ResetPasswordInput from '@/pages/reset-password/input'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    {
      path: '/corp_admin/login',
      name: 'ログイン',
      component: Login
    },
    {
      path: '/corp_admin/user',
      name: 'ユーザー管理',
      component: Account
    },
    {
      path: '/corp_admin/payment',
      name: 'お支払い情報 変更',
      component: Payment,
      props: true
    },
    {
      path: '/corp_admin/card',
      name: 'カード情報 変更',
      component: Card
    },
    {
      path: '/corp_admin/invoice',
      name: '請求書記載情報 変更',
      component: Invoice
    },
    {
      path: '/corp_admin/setting',
      name: '管理者情報 変更',
      component: Setting
    },
    {
      path: '/corp_admin/withdrawal',
      name: '管理者退会',
      component: Withdrawal
    },
    {
      path: '/corp_admin/reset-password/:token',
      name: 'パスワード設定',
      component: ResetPasswordInput
    },
    {
      path: '/corp_admin/reset-password',
      name: 'パスワード再設定',
      component: ResetPassword
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js